import axios from "axios";
import { url } from "../Config";

class GetGridsApi {
  undertakingApi = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/undertakingApi`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  DetailofRatingCommiteApi = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/viewRatingCommitteeGridApi`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  RatingMovementApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/ratingMovementApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  ratingmoventIGFApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getRatingMovementInvestmentGradeApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  newRatingsApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getNewRatingsApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  directorsDetails = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/viewDirectorsGridApi`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  
  sponsorshipDetail = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/viewSponsorsGridApi`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  criteriaGroupDetails = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/viewCriteriaGridApi`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  AnalystRotation = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/analystRotationApi`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  TeamRotation = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/teamRotationApi`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  LeadRcRotation = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/leadrcRotationApi`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  Movementmorethanoneform = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getMovementMoreThanOneNotchApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  RatingUpgradeDowngradeApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getRatingUpgradeDowngradeApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  MonitoringSurveillanceApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getMonitoringApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  UpdatingofmethodologiesApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getMethodologiesApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  UnsolicitedRatingsApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getUnsolicitedRatingsApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  RatingsBetweenTwoDatesApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/ratingsBetweenTwoDatesApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }
  FcBetweenTwoDatesApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/fileclosurereport/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  IcBetweenTwoDatesApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/get_ic_list_api/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }


  OutstandingOnSpecificDate = (startDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getOutstandingOnSpecificDateApi/${startDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  VisOutstandingOnSpecificDateApi = (startDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getVisOutstandingOnSpecificDateApi/${startDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  Tobereviewedratings = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/indexApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }


  RatingSwitchApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getRatingSwitchApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  PvtRatingsApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getPvtRatingsApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  NewRatingAgreementsApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/getNewRatingAgreementsApi/${startDate}/${EndDate}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  RatingWdApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/getRatingWdApi/${startDate}/${EndDate}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

 IndicativeRatingApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getIndicativeRatingApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

 HrHiringsApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getHrHiringsApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  OperationalDetails = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/getOperationalDetailsApi/${startDate}/${EndDate}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  RcHeldApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getRcHeldApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  RcOverdueApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/rcfilterApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  SectorStudiesApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/getSectorStudiesApi/${startDate}/${EndDate}`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  DefaultListApi = (startDate, EndDate) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/getDefaultListApi/${startDate}/${EndDate}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }

  ExRcRotation = () => {
    const res = async () => {
      const resp = await axios
        .get("https://209.97.168.200/pacrawizpackv3/public/api/ext-rc-rotation")
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  }
}



export default new GetGridsApi();
